/* eslint-disable react/no-multi-comp */
import React from "react"
import { css, randomInt } from "@jsUtils"
import { Headline, GridLines, Eyebrow } from "@shared"
import { PageSection } from "../PageSection"

// eslint-disable-next-line no-unused-vars
import Styles from "./advisoryBoard.module.scss"

/**
 * Tech Spec Section
 * @param {object} props - React props
 */
const AdvisoryBoard = props => {
  const { theme, color, people } = props
  const [ready, setReady] = React.useState(false)

  const boardMembers = people.map(person => {
    return (
      <div className={Styles.member} key={`${person.id}-${randomInt(0, Date.now())}`}>
        <Headline className={Styles.headline} size={5}>
          {person.url ? (
            <a href={person.url} target="_board-member">
              {person.name}
            </a>
          ) : (
            <>{person.name}</>
          )}
        </Headline>
        <p className={Styles.position}>{person.titlesOrganizations}</p>
      </div>
    )
  })

  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={theme} />
      <div className={Styles.wrapper}>
        <div className={Styles.header}>
          <Eyebrow className={Styles.eyebrow} color={color}>
            Board of Advisors
          </Eyebrow>
        </div>
        <div className={Styles.members}>{boardMembers}</div>
      </div>
    </PageSection>
  )
}

export default AdvisoryBoard
